export const GET_CART = 'GET_CART';
export const SET_CART = 'SET_CART';
export const QUANTITY_CHANGED = 'QUANTITY_CHANGED';
export const PROMOTIONS_QUANTITY = 'PROMOTIONS_QUANTITY';

// category
export const CATEGORY_NAV = 'CATEGORY_NAV';
